var _this = this;
import * as tslib_1 from "tslib";
import { orchestrator } from 'satcheljs';
import { newMailNotificationAction } from 'owa-app-notifications-core';
import getSelectedFolder from 'owa-mail-store/lib/utils/getSelectedFolder';
import { getFolderByDistinguishedId } from 'owa-folders';
import setUnseenCount from '../mutators/setUnseenCount';
import getStore from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
orchestrator(newMailNotificationAction, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var notification;
    return tslib_1.__generator(this, function (_a) {
        if (getSelectedFolder() !== getFolderByDistinguishedId('inbox') || document.hidden) {
            notification = actionMessage.notification;
            // If Focused inbox is enabled, we should only add "Focused" mails to the unseen count
            if (notification.InferenceClassification === 'Focused' ||
                !getUserConfiguration().UserOptions.IsFocusedInboxEnabled) {
                setUnseenCount(getStore().unseenMessages + 1);
            }
        }
        return [2 /*return*/];
    });
}); });
//# sourceMappingURL=onNewMessageOrchestrator.js.map